<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-row>
          <b-col>
            <b-overlay
              :show="loading"
              blur="2px"
              bg-color="dark"
            >
              <counter-card
                card-color="light-success"
                card-label="Yayınlandı"
                card-icon="CheckCircleIcon"
                :card-value="counters.published"
              />
            </b-overlay>
          </b-col>
          <b-col>
            <b-overlay
              :show="loading"
              blur="2px"
              bg-color="dark"
            >
              <counter-card
                card-color="light-warning"
                card-label="Planlandı"
                card-icon="ClockIcon"
                :card-value="counters.scheduled"
              />
            </b-overlay>
          </b-col>
          <b-col>
            <b-overlay
              :show="loading"
              blur="2px"
              bg-color="dark"
            >
              <counter-card
                card-color="light-primary"
                card-label="Abone Site"
                card-icon="GlobeIcon"
                :card-value="counters.sites"
              />
            </b-overlay>
          </b-col>
        </b-row>
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <b-overlay
          :show="loading"
          blur="2px"
          bg-color="dark"
        >
          <table-published :data-list="dataList.published" />
        </b-overlay>
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <b-overlay
          :show="loading"
          blur="2px"
          bg-color="dark"
        >
          <table-scheduled :data-list="dataList.scheduled" />
        </b-overlay>
      </b-col>
      <b-col
        cols="12"
      >
        <b-overlay
          :show="loading"
          blur="2px"
          bg-color="dark"
        >
          <table-logs :data-list="dataList.logs" />
        </b-overlay>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BCol,
  BRow,
  BOverlay,
} from 'bootstrap-vue'
import CounterCard from '@/views/Dashboard/Components/CounterCard.vue'
import TablePublished from '@/views/Dashboard/Components/TablePublished.vue'
import TableScheduled from '@/views/Dashboard/Components/TableScheduled.vue'
import TableLogs from '@/views/Dashboard/Components/TableLogs.vue'

export default {
  name: 'Manager',
  components: {
    BRow,
    BCol,
    BOverlay,
    CounterCard,
    TablePublished,
    TableScheduled,
    TableLogs,
  },
  computed: {
    counters() {
      return this.$store.getters['dashboard/counters']
    },
    dataList() {
      return this.$store.getters['dashboard/dataList']
    },
    loading() {
      return this.$store.getters['dashboard/loading']
    },
  },
  created() {
    this.getDashboard()
  },
  methods: {
    getDashboard() {
      this.$store.dispatch('dashboard/getDashboard')
    },
  },
}
</script>
